import { CircularProgress, Stack } from "@mui/material";

export function FullScreenPreloader() {
  return (
    <Stack
      width={"100%"}
      height={"100vh"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <CircularProgress size={"64px"} color="primary" />
    </Stack>
  );
}
